import { Verifiable } from './verifiable';

export class Email extends Verifiable {

    constructor(public email: string = '', verified: boolean = false) {
        super(verified);
    }
}